<template>
  <div>
    <div class="overflow-auto">
      <ts-loading-banner :loading="waiting">
        <table id="table-details">
          <thead>
            <tr>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width:200px"
              >
                {{ $t('quotation.feeType') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width:200px"
              >
                {{ $t('quotation.feeName') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 190px;"
              >
                {{ $t('quotation.description') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 70px;"
              >
                {{ $t('quotation.qty') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 99px;"
              >
                {{ $t('quotation.fee') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 93px;"
              >
                {{ $t('quotation.discountType') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 94px;"
              >
                {{ $t('quotation.discount') }}
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 81px;"
              >
                {{ $t('quotation.vat') }}(%)
              </th>
              <th
                class="ts-whitespace-no-wrap ts-uppercase"
                style="width: 90px;"
              >
                {{ $t('quotation.amount') }}
              </th>
              <th style="width:1%">
                <a href="#" class="text-primary" @click.prevent="addRow">
                  <i class="fa fa-plus"></i>
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in model.quot_detail_list" :key="index">
              <td valign="top">
                <a-select
                  v-model.number="detail.fee_type_id"
                  style="width: 100%"
                  :options="feeTypes"
                  @change="fetchFeeSetupDetail(detail)"
                />
                <div
                  class="validate"
                  v-if="errors.has('quot_detail_list.' + index + '.fee_type_id')"
                >
                  {{
                    errors.first('quot_detail_list.' + index + '.fee_type_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-select
                  v-model.number="detail.fee_setup_id"
                  style="width:100%"
                  :showSearch="true"
                  :options="
                    feeSetups.filter(f => f.fee_type_id == detail.fee_type_id)
                  "
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  optionFilterProp="children"
                  @change="onFeeSetupChange(detail)"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('quot_detail_list.' + index + '.fee_setup_id')
                  "
                >
                  {{
                    errors.first('quot_detail_list.' + index + '.fee_setup_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <input
                  v-model="detail.fee_description"
                  type="text"
                  class="form-control"
                />
              </td>
              <td valign="top">
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  v-model="detail.quantity"
                  @input="calculate"
                />
                <div
                  class="validate"
                  v-if="errors.has('quot_detail_list.' + index + '.quantity')"
                >
                  {{ errors.first('quot_detail_list.' + index + '.quantity') }}
                </div>
              </td>
              <td valign="top">
                <input
                  readonly
                  type="number"
                  step="any"
                  class="form-control"
                  v-model="detail.fee_amount"
                />
                <div
                  class="validate"
                  v-if="errors.has('quot_detail_list.' + index + '.fee_amount')"
                >
                  {{ errors.first('quot_detail_list.' + index + '.fee_amount') }}
                </div>
              </td>
              <td valign="top">
                <a-select
                  v-model="detail.discount_type"
                  style="width: 100%"
                  :options="[
                    { value: '$', label: '$' },
                    { value: '%', label: '%' }
                  ]"
                  @change="calculate"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('quot_detail_list.' + index + '.discount_type')
                  "
                >
                  {{
                    errors.first('quot_detail_list.' + index + '.discount_type')
                  }}
                </div>
              </td>
              <td valign="top">
                <input
                  v-model="detail.discount_rate"
                  type="number"
                  class="form-control"
                  @input="calculate"
                />
              </td>
              <td valign="top">
                <input
                  type="number"
                  class="form-control"
                  v-model="detail.vat_rate"
                />
              </td>
              <td valign="top">
                <input
                  readonly
                  type="number"
                  class="form-control"
                  v-model="detail.amount_include_vat"
                />
              </td>
              <td class="text-center" valign="top">
                <a
                  href="#"
                  class="text-red ts-mt-3"
                  @click.prevent="removeRow(index)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr>
							<td colspan="7"></td>
              <td class="text-right">
                <strong>{{ $t('quotation.total') }} :</strong>
              </td>
              <td>
                <input
                  :value="model.total_amount"
                  type="text"
                  class="form-control"
                  readonly
                />
                <div class="validate" v-if="errors.has('total_amount')">
                  {{ errors.first('total_amount') }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { clone } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'manualDetailCreateForNoEnroll',
  props: ['value', 'validate'],
  data() {
    return {
      waiting: false,
      model: {},
      errors: new Errors(),
      newRow: {
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        duration_in_month: null,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        ac_term_id: null,
        grade_id: null,
      },
      feeTypes: [],
      feeSetups: [],
      feeItemDetails: [],
    }
  },
  created() {
    this.model = this.value
    this.fetchFeeType()
  },
  methods: {
    ...mapActions('quotation', ['formViewModel']),
    addRow() {
      this.model.quot_detail_list.push(clone(this.newRow))
    },
    removeRow(index) {
      this.model.quot_detail_list.splice(index, 1)
    },
    // fetch fee type when component created
    fetchFeeType() {
      this.waiting = true
      this.formViewModel({
        fnName: 'feeType'
      })
        .then(response => {
          this.feeTypes = response.feeType.map(el => ({
            value: el.fee_type_id,
            label: el.fee_type_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // fetch fee setup detail when fee type change
    async fetchFeeSetupDetail(row, waiting = 0) {
      if (!this.model.ac_term_id || !this.model.grade_id) {
        this.$toasted.error('Academic term or grade no selected!')
        return
      }

      if (!this.feeItemDetails.hasOwnProperty(row.fee_type_id)) {
        this.waiting = true
        let response = await this.formViewModel({
          ac_term_id: this.model.ac_term_id,
          grade_id: this.model.grade_id,
          fee_type_id: row.fee_type_id,
          quotation_date: this.model.quot_date,
          fnName: 'feeDetail'
        })

        this.feeItemDetails = Object.assign(
          {},
          this.feeItemDetails,
          response['feeDetail']
        ) // store temporary fee item detail when change fee type
        this.pushNewValueFeeSetup(
          Object.values(response['feeDetail']).flat()
        )

        this.waiting = false
      }

      this.clearRow(row)
    },
    // push a new value to be select on fee name
    pushNewValueFeeSetup(value) {
      value
        .filter(v => v.fee_setup_id > 0)
        .forEach(el => {
          if (
            !this.feeSetups.filter(f => f.value == el.fee_setup_id).length > 0
          ) {
            this.feeSetups.push({
              fee_type_id: el.fee_type_id,
              value: el.fee_setup_id,
              label: el.fee_name
            })
          }
        })
    },
    // set value to each column in details
    onFeeSetupChange(item) {
      this.feeItemDetails[item.fee_type_id]
        .filter(f => f.fee_setup_id == item.fee_setup_id)
        .forEach(el => {
          if (!this.model.remark) {
            this.model.remark = el.discount_remark
          }
          item.fee_description = el.fee_name // description is a fee name
          item.quantity = 1
          item.duration_in_month = el.duration_in_month
          item.fee_amount = el.fee_amount
          item.discount_rate = el.discount_rate
          item.ac_term_id = el.ac_term_id
          item.grade_id = el.grade_id
        })
      this.calculate()
    },
    // calculate amount
    calculate() {
      var price = 0
      if (this.model.quot_detail_list.length > 0) {
        this.model.quot_detail_list.forEach(detail => {
          detail.quantity = detail.quantity ? detail.quantity : 1
          price = detail.fee_amount ? detail.fee_amount * detail.quantity : 0
          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? price * _.round(detail.discount_rate / 100, 4)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }
          detail.total_amount = price - detail.discount_amount
          detail.vat_amount = detail.vat_rate
            ? detail.total_amount * _.round(detail.vat_rate / 100, 4)
            : 0
          detail.amount_include_vat = _.round(
            detail.total_amount + detail.vat_amount,
            2
          )
        })

        let sumAmountIncludeVat = _.sumBy(
          this.model.quot_detail_list,
          'amount_include_vat'
        )
        this.model.total_amount = sumAmountIncludeVat
      } else {
        this.model.total_amount = 0
        this.model.next_payment_date = null
      }
    },
    // set each row to default by fee type change
    clearRow(row) {
      row.fee_setup_id = null
      row.fee_description = ''
      row.quantity = 1
      row.duration_in_month = null
      row.fee_amount = 0
      row.discount_rate = 0
      row.discount_amount = 0
      row.total_amount = 0
      row.vat_rate = 0
      row.vat_amount = 0
      row.amount_include_vat = 0
      row.ac_term_id = null
      row.grade_id = null
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}
#table-details > thead > tr > th {
  padding: 5px 4px;
  background: #f2f3f4;
}
#table-details > tbody > tr > td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
